module.exports = __webpack_public_path__ + "media/images/foal_copy-18e4e5c53e87e55822465472d469a5d2.jpg";